module.exports = __webpack_public_path__ + "media/images/athletes/3412-1320cd53a0cfdb70e47be607fe130afa.png";